import { ICON__lock, ICON__lock_open } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { REMOTE__generation_update_status_lock } from '@/state/generation/status/REMOTE__generation_update_status_lock';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';

interface PROPS {
  generation: DTO__generation;
}

export function G_HEADER__generations_history_item__button_lock({ generation }: PROPS) {
  const dispatch = use_dispatch();

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let generation_new = generation.clone();
    generation_new.status = generation_new.status == ENUM__generation_status.LOCKED ? ENUM__generation_status.ADJUSTING : ENUM__generation_status.LOCKED;

    await dispatch(REMOTE__generation_update_status_lock(generation_new));
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */
  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="full-6"
      {...{ onClick }}
      className=""
      disabled={is_disabled()}
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={generation.status == ENUM__generation_status.LOCKED ? ICON__lock_open : ICON__lock}
    />
  );
}
